import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ThankYou() {
  const navigate = useNavigate();

  useEffect(() => {
    // Set page title for screen readers and SEO
    document.title = "Thank You - Dang Good Leather";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="thank-you-container" role="main">
      <h1>Thank You!</h1>
      <p role="status" aria-live="polite">
        Your order has been placed successfully.
      </p>
      <p>You’ll receive a confirmation email shortly.</p>
      <button onClick={() => navigate("/")} className="action-button">
        Return Home
      </button>
    </div>
  );
}
